import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../services/auth/auth-service';
import { LocalStorageService } from '../../services/localStorage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);

  canActivate(): boolean | UrlTree {
    const role = this.localStorageService.getRole();


    // Vérifie si l'utilisateur est connecté
    if (this.authService.isAuthenticated()) {
      // Redirige vers la page d'accueil ou tableau de bord
      if (role === 'SUPER_ADMIN') {
        return this.router.createUrlTree(['/super-admin/dashboard']);
      } else if (role === 'ADMIN') {
        return this.router.createUrlTree(['/admin/dashboard']);
      } else if (role === 'GERANT' || role === 'AGENT' || role === 'MANAGER') {
        return this.router.createUrlTree(['/manager/dashboard']);
      } else if (role ==='FREELANCE_COACH') {
        return this.router.createUrlTree(['/coach/dashboard']);
      }

      return false; // Bloque l'accès à la route
    }
    return true; // Autorise l'accès
  }
}
